"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _collaborators = _interopRequireDefault(require("./collaborators"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Clients = /*#__PURE__*/function () {
  function Clients(registry) {
    (0, _classCallCheck2["default"])(this, Clients);
    this._api = registry;
    this.Collaborators = new _collaborators["default"](registry.ClientAccess, {
      parentRoutes: {
        get: 'client_ids.client_id',
        list: 'client_ids.client_id',
        set: 'client_ids.client_id'
      }
    });
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Clients, [{
    key: "_addState",
    value: function _addState(fieldMask, clients) {
      // Ensure to set STATE_REQUESTED if needed, which gets stripped as null
      // value from the backend response.
      if (fieldMask && fieldMask.field_mask.paths.includes('state') && !('state' in clients)) {
        clients.state = 'STATE_REQUESTED';
      }

      return clients;
    }
  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var _this = this;

        var fieldMask, response, clients;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context.next = 3;
                return this._api.ClientRegistry.List(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                response = _context.sent;
                clients = _marshaler["default"].payloadListResponse('clients', response);
                clients.clients.map(function (clients) {
                  return _this._addState(fieldMask, clients);
                });
                return _context.abrupt("return", clients);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(params, selector) {
        var _this2 = this;

        var fieldMask, response, clients;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.EntityRegistrySearch.SearchClients(undefined, _objectSpread(_objectSpread({}, params), fieldMask));

              case 3:
                response = _context2.sent;
                clients = _marshaler["default"].payloadListResponse('clients', response);
                clients.clients.map(function (clients) {
                  return _this2._addState(fieldMask, clients);
                });
                return _context2.abrupt("return", clients);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function search(_x3, _x4) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(id, selector) {
        var fieldMask, response, client;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context3.next = 3;
                return this._api.ClientRegistry.Get({
                  routeParams: {
                    'client_ids.client_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context3.sent;
                client = this._addState(fieldMask, _marshaler["default"].payloadSingleResponse(response));
                return _context3.abrupt("return", client);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getById(_x5, _x6) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var ownerId,
            client,
            isUserOwner,
            routeParams,
            response,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                ownerId = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : this._defaultUserId;
                client = _args4.length > 1 ? _args4[1] : undefined;
                isUserOwner = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : true;
                routeParams = isUserOwner ? {
                  'collaborator.user_ids.user_id': ownerId
                } : {
                  'collaborator.organization_ids.organization_id': ownerId
                };
                _context4.next = 6;
                return this._api.ClientRegistry.Create({
                  routeParams: routeParams
                }, {
                  client: client
                });

              case 6:
                response = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].unwrapClients(response));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(id, patch) {
        var mask,
            response,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                mask = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : _marshaler["default"].fieldMaskFromPatch(patch);
                _context5.next = 3;
                return this._api.ClientRegistry.Update({
                  routeParams: {
                    'client.ids.client_id': id
                  }
                }, {
                  client: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].unwrapClients(response));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateById(_x7, _x8) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }, {
    key: "restoreById",
    value: function () {
      var _restoreById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id) {
        var response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.ClientRegistry.Restore({
                  routeParams: {
                    client_id: id
                  }
                });

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function restoreById(_x9) {
        return _restoreById.apply(this, arguments);
      }

      return restoreById;
    }()
  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(applicationId) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.ClientRegistry.Delete({
                  routeParams: {
                    client_id: applicationId
                  }
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteById(_x10) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(id) {
        var response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.ClientRegistry.Purge({
                  routeParams: {
                    client_id: id
                  }
                });

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function purgeById(_x11) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }()
  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(id) {
        var result;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.ClientAccess.ListRights({
                  routeParams: {
                    client_id: id
                  }
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getRightsById(_x12) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }()
  }]);
  return Clients;
}();

var _default = Clients;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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